import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Loader2, ChevronRight, Layers, DollarSign, Trophy, Compass, BarChart } from "lucide-react";
import { AdSlot } from "../components/shared";
import { Header } from "../components/Header";

export const TrainingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);
  const isQuickDrill = new URLSearchParams(location.search).get("quick") === "true";

  useEffect(() => {
    let cancelled = false;
    const fetchModules = async () => {
      try {
        const response = await api.get("/modules");
        if (!cancelled) { setModules(response.data); if (isQuickDrill) navigate("/scenario"); }
      } catch { toast.error("Failed to load training modules"); } finally { if (!cancelled) setLoading(false); }
    };
    fetchModules();
    return () => { cancelled = true; };
  }, [isQuickDrill, navigate]);

  const iconMap = { cards: Layers, layers: Layers, "dollar-sign": DollarSign, trophy: Trophy, compass: Compass, "bar-chart": BarChart };

  if (loading) return <div className="min-h-screen bg-[#050505]"><Header /><div className="flex items-center justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-[#D4AF37]" /></div></div>;

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="training-page">
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8"><h1 className="text-2xl sm:text-3xl font-semibold mb-2">Training Modules</h1><p className="text-neutral-400">Choose a category to start practicing</p></div>
        <AdSlot size="banner" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {modules.map((mod) => {
            const IconComponent = iconMap[mod.icon] || Layers;
            return (
              <button key={mod.module_id} onClick={() => navigate(`/scenario?category=${mod.category}`)}
                className="text-left bg-[#121212] border border-white/5 rounded-lg p-6 transition-all hover:border-white/10 hover:bg-[#161616]"
                data-testid={`module-${mod.category}`}>
                <div className="flex items-start justify-between mb-4">
                  <div className="w-12 h-12 rounded-lg flex items-center justify-center bg-[#D4AF37]/10"><IconComponent className="w-6 h-6 text-[#D4AF37]" /></div>
                </div>
                <h3 className="text-lg font-medium mb-1">{mod.name}</h3><p className="text-sm text-neutral-400 mb-4">{mod.description}</p>
                <div className="flex items-center justify-between text-sm"><span className="text-neutral-500">{mod.scenario_count} scenarios</span><span className="text-[#D4AF37] flex items-center gap-1">Start <ChevronRight className="w-4 h-4" /></span></div>
              </button>
            );
          })}
        </div>
      </main>
    </div>
  );
};
